import { ExtendBorrowDetailComponent } from "../../../components/borrowSystem/ChangeAndExtendBorrowForm/ExtendBorrowDetailComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
export function ExtendBorrowDetailContainer() {
  const titleName =
    "รายละเอียดการแจ้งเลื่อนหลักสูตรการฝึกอบรมหรือทดสอบมาตรฐานฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <ExtendBorrowDetailComponent />
      <Footer />
    </div>
  );
}
